document.addEventListener('DOMContentLoaded', function() {
  const features = document.querySelectorAll('.about-design__feature');
  const mainImage = document.querySelector('.about-design__main-image');
  
  if (features.length === 0) return;
  
  features.forEach(function(feature) {
    feature.addEventListener('click', function() {
      features.forEach(function(f) {
        f.classList.remove('about-design__feature--active');
        f.classList.add('about-design__feature--inactive');
        f.style.borderColor = '#EEEEEE';
      });
      
      this.classList.remove('about-design__feature--inactive');
      this.classList.add('about-design__feature--active');
      this.style.borderColor = '#1B8C91';
      
      if (mainImage) {
        const newImageUrl = this.getAttribute('data-feature-image');
        if (newImageUrl) {
          mainImage.style.opacity = '0';
          setTimeout(function() {
            mainImage.src = newImageUrl;
            mainImage.style.opacity = '1';
          }, 200);
        }
      }
    });
  });
  
  if (features.length > 0) {
    features[0].classList.add('about-design__feature--active');
  }
});
